import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../services/accountService';
import './Login.css';
import logo from '../../assets/icon.png';
import Breadcrumbs from '../../components/Breadcrumbs';
import SeoPageComponent from '../../components/SeoPageComponent/SeoPageComponent';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { success, error } = await loginUser({ email, password }, navigate);

      if (success) {
        navigate('/account');
      } else {
        setError(error || 'Invalid credentials.');
      }
    } catch (err) {
      setError(err.message || 'An unexpected error occurred.');
    }
  };

  const breadcrumbLinks = [{ href: '/', label: 'Home' }, { label: 'Login' }];

  const pageTitle = `Autentificare - ${process.env.REACT_APP_NAME} | Portal Achiziții Publice`;
  const pageDescription = `Autentifică-te pe ${process.env.REACT_APP_NAME} pentru a accesa cele mai recente licitații publice și resurse dedicate achizițiilor publice din România.`;
  const pageKeywords = `autentificare, login, achiziții publice, licitații publice, Go4Projects, acces platformă, autentificare utilizator`;
  const pageUrl = `https://${process.env.REACT_APP_DOMAIN}/login`;

  return (
    <>
      <SeoPageComponent
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        pageKeywords={pageKeywords}
        pageUrl={pageUrl}
        logoUrl={logo}
      />
      <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-green-100 py-12">
        <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-10 border-t-8 border-indigo-500 animate-fade-in">
          <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
          <h2 className="text-3xl md:text-4xl font-extrabold text-indigo-700 mb-2 text-center">
            Bine ai revenit!
          </h2>
          <p className="text-gray-500 text-center mb-8 text-lg">
            Autentifică-te și accesează rapid toate oportunitățile din
            construcții.
          </p>
          {error && (
            <p className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4 text-center">
              {error}
            </p>
          )}
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Adresă de email"
                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
                required
              />
            </div>
            <div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Parolă"
                className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-400 outline-none"
                required
              />
            </div>
            <div className="flex justify-end">
              <a
                href="/forgot-password"
                className="text-indigo-600 font-semibold hover:underline text-sm"
              >
                Am uitat parola?
              </a>
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-indigo-500 to-green-500 hover:from-indigo-600 hover:to-green-600 text-white font-bold py-3 rounded-xl shadow-lg text-lg transition-all duration-300"
            >
              Autentificare
            </button>
          </form>
          <div className="flex items-center my-6">
            <span className="flex-1 h-px bg-gray-200"></span>
            <span className="mx-4 text-gray-400 font-semibold">sau</span>
            <span className="flex-1 h-px bg-gray-200"></span>
          </div>
          <div className="text-center">
            <p className="text-gray-600">
              Nu ai un cont?{' '}
              <a
                href="/register"
                className="text-indigo-600 font-bold hover:underline"
              >
                Creează cont nou
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
